import { prop } from "../../decorators/property";

export class KeyParagraphQuoteModel extends Backbone.AssociatedModel {
    @prop() public Id: string;
    @prop() public CitingCaseTitle: string;
    @prop() public CitingCaseCourt: string;
    @prop() public CitingCaseId: string;
    @prop() public CitingParagraphNumber: number;

    constructor(options?) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/key-paragraph-quote.ts